import { Title4 } from "@components/Typography";
import { Routes, StorageKey } from "@ctypes";
import { useLogout } from "@hooks";
import { Translations, i18n } from "@i18n";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Placeholder } from "./styles";

export const RightButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem(StorageKey.Token);

  const { logout } = useLogout();

  if (location.pathname === Routes.SignUp) {
    return (
      <Container onClick={() => navigate(Routes.EmailLogin)}>
        <Title4>{i18n.t(Translations.HeaderLoginButton)}</Title4>
      </Container>
    );
  }

  if (location.pathname === Routes.EmailLogin) {
    return (
      <Container onClick={() => navigate(Routes.SignUp)}>
        <Title4>{i18n.t(Translations.HeaderSignUpButton)}</Title4>
      </Container>
    );
  }

  if (token) {
    return (
      <Container
        onClick={() => {
          logout();
          navigate(Routes.Auth, { replace: true });
        }}
      >
        <Title4>{i18n.t(Translations.HeaderLogoutButton)}</Title4>
      </Container>
    );
  }

  return <Placeholder />;
};
